import { Tooltip } from 'app/components/BasicTooltips/Tooltip';
import { useTranslation } from 'react-i18next';
import * as React from 'react';
import { Link as MuiLink } from '@material-ui/core';
import { translations } from 'locales/translations';

import { RenderPageType } from 'app/Layout/FrontendLayout/slice/type';
import useSidePanelState, {
  SidePanelOpenState,
} from 'app/hooks/useSidePanelOpen';
import { PrimaryActionDynamic } from 'app/components/BasicTable/components/TableCard/PrimaryAction';
import { ServiceTypeUnion } from 'enums/ServiceTypes';

export const AssetLink = (props: {
  id?: number;
  serviceId?: number;
  serviceType?: ServiceTypeUnion;
  children: React.ReactNode;
  title?: string;
  useSidePanel?: boolean;
  openPanelWithCover?: (state: SidePanelOpenState) => void;
}) => {
  const { t } = useTranslation();
  const openAsset = useOpenAssetPopUp();
  const open = () => {
    openAsset(
      {
        Id: props.id,
        serviceId: props.serviceId,
        serviceType: props.serviceType,
        useSidePanel: props.useSidePanel,
      },
      props.openPanelWithCover,
    );
  };
  return (
    <Tooltip title={props.title ?? t(translations.ShowAssetSidePanel)}>
      <MuiLink
        style={{ cursor: 'pointer' }}
        onClick={() => open()}
        color="textPrimary"
      >
        {props.children}
      </MuiLink>
    </Tooltip>
  );
};

export const useOpenAssetPopUp = () => {
  const { openPanel } = useSidePanelState();
  return React.useCallback(
    (
      props: {
        Id?: number;
        serviceId?: number;
        serviceType?: ServiceTypeUnion;
        useSidePanel?: boolean;
      },
      openPanelWithCover?: (state: SidePanelOpenState) => void,
    ) => {
      const panelState = {
        renderPageType: RenderPageType.AssetDetails,
        renderPageProps: props,
        expanded: false,
        useSidePanel: props.useSidePanel,
        isCover: props.useSidePanel,
      } as SidePanelOpenState;
      if (!!openPanelWithCover) {
        openPanelWithCover(panelState);
      } else {
        openPanel({
          renderPageType: RenderPageType.AssetDetails,
          renderPageProps: props,
          expanded: false,
          useSidePanel: false,
          isCover: false,
        } as SidePanelOpenState);
      }
    },
    [openPanel],
  );
};

//used for Dashboard tadles
export const OpenAssetPrimaryAction: PrimaryActionDynamic<{
  Id?: number;
  serviceId?: number;
  serviceType?: ServiceTypeUnion;
}> = (openPanel, row, toggle, user, useSidePanel) => {
  openPanel({
    renderPageType: RenderPageType.AssetDetails,
    renderPageProps: {
      Id: row.original.Id,
      serviceId: row.original.serviceId,
      serviceType: row.original.serviceType,
      useSidePanel: true,
    },
    useSidePanel: useSidePanel,
    expanded: false,
    isCover: useSidePanel,
  });
};
